import cx from 'classix';
import { PillBadge } from '@platform/components';
import type { Testimonial, TestimonialBannerColor } from './data/testimonials';
import QuoteIcon from '../../svg/QuoteIcon';

const BANNER_BG_BY_COLOR: Record<TestimonialBannerColor, string> = {
  blue: 'bg-secondary-brand-30',
  yellow: 'bg-warning-30',
  green: 'bg-success-25',
  purple: 'bg-purple-25',
};

const ICON_COLOR: Record<string, string> = {
  blue: 'text-brand-500',
  yellow: 'text-warning-300',
};

export const TestimonialCard = ({ testimonial }: { testimonial: Testimonial }) => {
  const bannerBg = BANNER_BG_BY_COLOR[testimonial.bannerColor] || 'bg-secondary-brand-30';
  const iconColor = ICON_COLOR[testimonial.iconColor] || 'text-brand-500';

  return (
    <div className='flex w-full flex-col rounded-2xl border border-gray-100 bg-gray-25 sm:w-[384px] sm:shrink-0'>
      <div className='relative h-[92px] overflow-hidden rounded-t-2xl border-b border-gray-100 bg-white'>
        <div
          className={cx(
            'absolute inset-x-[-30px] -top-[30px] h-[120px] rotate-[6.53deg] rounded-[20px]',
            bannerBg,
          )}
        />
        <div className='absolute left-5 top-[17px] h-14 w-14 overflow-hidden rounded-full border border-gray-100 bg-white'>
          <img src={testimonial.avatarUrl} alt={testimonial.name} className='h-full w-full object-cover' />
        </div>
        <QuoteIcon className={cx('absolute right-5 top-[10px]', iconColor)} />
      </div>
      <div className='flex flex-col gap-5 rounded-b-2xl border border-gray-100 bg-white p-5 sm:flex-1'>
        <div className='flex flex-col gap-4 sm:flex-1'>
          <div className='flex flex-col gap-1'>
            <h3 className='text-xl font-bold leading-[1.5] text-gray-600'>
              {testimonial.name}
            </h3>
            <p className='text-base font-medium leading-6 text-gray-600'>
              {testimonial.title}
            </p>
          </div>
          <p className='text-lg font-normal leading-7 text-gray-600'>
            {testimonial.quote}
          </p>
        </div>
        <div className='flex flex-wrap gap-2'>
          <PillBadge color='blue' variant='plain' size='lg'>
            {testimonial.skillTag}
          </PillBadge>
          <PillBadge color='success-25' variant='plain' size='lg'>
            {testimonial.causeTag}
          </PillBadge>
        </div>
      </div>
    </div>
  );
};
